<template>
  <div v-if="value" class="auth-dialog">
    <div class="hd">
      <h2 v-if="!isConfirm">
        元气UP主认证提醒
      </h2>
      <span class="btn-close" @click="$emit('input', false)" />
    </div>
    <div class="bd">
      <dl>
        <dd v-if="isConfirm">
          作品下载量达到100(当前{{ nowDownloads }})，且认证为元气UP，才能上传付费壁纸哦~
        </dd>
        <span v-else>
          <dd>您的作品下载量还没有到达100(当前{{ nowDownloads }})，暂不支持申请元气UP（OWO）</dd>
          <dd>继续上传优质作品提升下载量吧~</dd>
        </span>
        <dd><br></dd>
        <dd>若您可熟练使用AE/Live2D/spine等动效制作软件，可联系运营人员</dd>
        <dd>QQ2493045441，进行人工优先审核，并可获得官方额外资源扶持。</dd>
      </dl>
    </div>
    <div class="bt">
      <a v-if="!isConfirm" class="gb-btn btn" rel="noopener noreferrer" @click="handleUpload">上传作品</a>
      <div v-else class="confirm">
        <a class="gb-btn btn" rel="noopener noreferrer" @click="handleUpAuth">认证元气UP</a>
        <a class="gb-btn btn" rel="noopener noreferrer" @click="$emit('input', false)">我知道了</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpAuthDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    nowDownloads: {
      type: Number,
      require: true,
      default: 0,
    },
  },
  methods: {
    handleUpload() {
      this.$router.push('/creation')
    },
    handleUpAuth() {
      this.$router.push('/contract/author')
    },
  },
}
</script>

<style scoped lang="scss">
.auth-dialog {
  width: 480px;
  background: #000000;
  border-radius: 10px;
}
.hd {
  position: relative;
  text-align: center;
  overflow: hidden;
  height: 34px;
  h2 {
    color: #fff;
    font-size: 14px;
    line-height: 34px;
    padding: 30px 0 0 0;
  }
}
.btn-close {
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  &:hover {
    &::before {
      background-position: -21px 0;
    }
  }
  &:active {
    &::before {
      background-position: -42px 0;
    }
  }
  &::before {
    content: '';
    display: inline-block;
    width: 21px;
    height: 21px;
    background: url('~@/assets/images/close.png') 0 0 no-repeat;
  }
}
.bd {
  width: 420px;
  margin: 0 61px 0 47px;
}
dl {
  padding-top: 30px;
  line-height: 24px;
  font-size: 14px;
  color: #fff;
}
dd {
  margin-bottom: 5px;
  padding-left: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.strong {
  color: #E88E01;
}
.bt {
  height: 80px;
}
.btn {
  display: block;
  user-select: none;
  cursor: pointer;
  margin: 20px auto;
  width: 240px;
  height: 40px;
  color: #333;
  text-align: center;
  line-height: 40px;
  background: #F4C000;
  border-radius: 8px;
}
.confirm {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 70px;
  gap: 23px;
}
</style>
